function type(value) {
    return typeof value === 'boolean';
}

function equals(value, length) {
    return value === length;
}

export {
    type,
    equals,
};
